import lang from '../../../../lib/language';

import NotSuppliedIcon from '../../../../assets/img/icon_notsupplied.svg';
import AfterHoursIcon from '../../../../assets/img/marketStates/after-hours.svg';
import PreMarketIcon from '../../../../assets/img/marketStates/pre-market.svg';
import BlueTickIcon from '../../../../assets/img/tick-circle.svg';
import { getEarningsCallTimeState } from '../../earningsCalendar.helpers';

import styles from './EarningsStatusBadge.module.scss';

type Props = {
  /** Raw `HH:mm:ss` from the response, not the formatted label. */
  time: string | undefined;
  reportStatus: string | undefined;
};

const EarningsStatusBadge = ({ time, reportStatus }: Props): JSX.Element => {
  const state = getEarningsCallTimeState(time, reportStatus);

  if (state === 'reported') {
    return (
      <span className={styles.earningsTime}>
        <span className={styles.reportedIcon}>
          <img src={BlueTickIcon} alt="blue tick icon" />
        </span>
        <span className={styles.timeText}>
          {lang.commonDiscoverCalenderSectionTimeReported()}
        </span>
      </span>
    );
  }

  if (state === 'afterClose') {
    return (
      <span className={styles.earningsTime}>
        <span className={styles.afterCloseIcon}>
          <img src={AfterHoursIcon} alt="after hours icons" />
        </span>
        <span className={styles.timeText}>
          {lang.commonDiscoverCalenderSectionTimeAfterMarketClose()}
        </span>
      </span>
    );
  }

  if (state === 'beforeOpen') {
    return (
      <span className={styles.earningsTime}>
        <span className={styles.beforeOpenIcon}>
          <img src={PreMarketIcon} alt="before open icon" />
        </span>
        <span className={styles.timeText}>
          {lang.commonDiscoverCalenderSectionTimeBeforeMarketOpen()}
        </span>
      </span>
    );
  }

  return (
    <span className={styles.earningsTime}>
      <span className={styles.notSuppliedIcon}>
        <img src={NotSuppliedIcon} alt="not supplied icon" />
      </span>
      <span className={styles.timeText}>
        {lang.commonDiscoverCalenderSectionNotSupplied()}
      </span>
    </span>
  );
};

export default EarningsStatusBadge;
